let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("baSOi")).then(() => parcelRequire('2gR6K'));